import { render, staticRenderFns } from "./createInventory.vue?vue&type=template&id=63ccc4b4"
import script from "./createInventory.vue?vue&type=script&lang=js"
export * from "./createInventory.vue?vue&type=script&lang=js"
import style0 from "./createInventory.vue?vue&type=style&index=0&id=63ccc4b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports